import { AppConfig } from "src/app/app-config";

export const environment: AppConfig = {
  production: false,
  serviceWorker: true,
  authApiURI: 'https://uat-auth.talentpoint.pl/api',
  resourceApiURI: 'https://uat-api.talentpoint.pl/api',
  authority: 'https://uat-auth.talentpoint.pl',
  client_id: 'angularHRDP',
  redirect_uri: 'https://uat.talentpoint.pl/auth-callback',
  post_logout_redirect_uri: 'https://uat.talentpoint.pl/',
  // forgotPassword_uri: 'http://HRDPtest.pl/#/forgotPassword',
  response_type: 'code',
  scope: 'openid profile email offline_access hrdp.api.read',
  filterProtocolClaims: true,
  loadUserInfo: true,
  automaticSilentRenew: true,
  useRefreshToken: true,
  silent_redirect_uri: 'https://uat.talentpoint.pl/silent-refresh.html',
  resourceApiCacheExpirationTimeSec: 120,
  simplysignApiURI: 'https://model.simplysign.webnotarius.pl',
  simplySignResponseType: 'code',
  simplySignClientId: 'fUeskHz92YCyf647UNQU',
  simplySignRedirectUri: 'http://uat.talentpoint.pl/auth-callback',
  noActiveUserTTL: 900000,
  noActiveUserMessageTTLLimit: 60000,
  renewTimeBeforeTokenExpiresInSeconds: 360,
  checkUpdatesEverySeconds: 600,
  baseUrl: "https://uat.talentpoint.pl/",
  refreshTokenRetryInSeconds: 5,
  tokenRefreshInSeconds: 30,
  recaptchaSiteKey: '6Leo5MAZAAAAAO5Vh2triA5-sQuvUpAa6sRoYguH',
  realtimeRefreshThrottleMs: 2000,
  telemetry: {
    enabled: false,
    serviceName: 'hrdp-app-uat',
    collectorUrl: '',
    traceSampleRate: 1.0,
    enableConsoleExporter: false,
    propagateTraceHeaderCorsUrls: [
      'https://uat-auth.talentpoint.pl.*',
      'https://uat-api.talentpoint.pl.*'
    ]
  }
};
